import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, zip } from 'rxjs';
import { map, switchMapTo } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { PluginLoaderService } from '../../shared/plugin-loader.service';
import { Getter } from '../../base/interfaces';
declare const AMap: any;

const TAG = 'AmapPolyline';

@Injectable()
export class AmapPolylineService implements Getter<AMap.Polyline> {
  private polyline: any;
  private polyline$ = new ReplaySubject<any>(1);
  private editor: any;
  private editor$ = new ReplaySubject<any>(1);

  constructor(
    private amaps: AMapService,
    private logger: LoggerService,
    private ngZone: NgZone,
    private plugins: PluginLoaderService,
  ) {}

  /**
   * è·åæçº¿
   */
  get() {
    return this.polyline$.asObservable();
  }

  /**
   * åå»ºæçº¿ AMap.Polyline
   * @param options éé¡¹
   */
  create(options: AMap.Polyline.Options) {
    return this.amaps.get().pipe(
      map(m => {
        options.map = m;
        this.polyline = this.ngZone.runOutsideAngular(() => new AMap.Polyline(options));
        this.logger.d(TAG, 'new Polyline created.');
        this.polyline$.next(this.polyline);
        this.polyline$.complete();
        return this.polyline;
      }),
    );
  }

  /**
   * éæ¯æçº¿
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'Polyline destroyed.');
      this.polyline = null;
    });
  }

  getEditor() {
    // plugin is loading:
    return this.editor$.asObservable();
  }

  /**
   * å è½½ç¼è¾æä»¶
   */
  loadEditor() {
    return this.plugins.load('AMap.PolyEditor');
  }

  /**
   * åå»ºç¼è¾å¨
   */
  createEditor() {
    return this.loadEditor().pipe(
      switchMapTo(zip(this.amaps.get(), this.get())),
      map(([m, p]) => {
        this.editor = this.ngZone.runOutsideAngular(() => new AMap.PolyEditor(m, p));
        this.logger.d(TAG, 'new PolyEditor created.');
        this.editor$.next(this.editor);
        this.editor$.complete();
        return this.editor;
      }),
    );
  }

  /**
   * å¼å³ç¼è¾å¨
   * @param v å¼å³éé¡¹
   */
  toggleEditor(v: boolean) {
    if (v && !this.editor) {
      this.createEditor().subscribe(editor => editor.open());
      return;
    }

    if (this.editor) {
      if (v) {
        this.editor.open();
      } else {
        this.editor.close();
      }
    }
  }
}
